import lottie from 'lottie-web';
import { loadFonts } from '@loaders/FontLoader';
import { disablePointerEvents } from '@utils/pointer-events-control';

export default class LoadScene extends Phaser.Scene {
  constructor() {
    super({ key: 'LoadScene' });
  }

  async preload() {
    this.load.json('loading-anim', 'assets/loadAnims/cuemath_loading.json');
    await loadFonts();
  }

  create() {
    this.loadingAnim = this.addLoaderLottie(
      this.cameras.main.width / 2,
      this.cameras.main.height / 2,
    );

    this.assetsLoad();
    this.load.start();

    this.load.on(
      'progress',
      () => {
        this.loadingAnim.anim.playSegments([0, 25], true);
      },
      this,
    );

    this.load.on(
      'complete',
      () => {
        this.loadingAnim.anim.loop = false;
        this.loadingAnim.anim.playSegments([26, 41], true);
        this.loadingAnim.anim.addEventListener('complete', () => {
          disablePointerEvents();
          this.scene.start('StartScene');
        });
      },
      this,
    );
  }

  addLoaderLottie(_x, _y) {
    const lottieRef = this.add
      .dom(_x - this.cameras.main.width / 2, _y - this.cameras.main.height / 2, 'div')
      .setScale(0.7);

    const lottieDiv = lottieRef.node;
    lottieDiv.style.height = '100%';
    lottieDiv.style.width = '100%';

    const lottieAnim = lottie.loadAnimation({
      container: lottieDiv,
      renderer: 'svg',
      loop: true,
      autoplay: false,
      animationData: this.cache.json.get('loading-anim'),
    });

    return { anim: lottieAnim, dom: lottieRef };
  }

  assetsLoad() {
    this.load.plugin(
      'rexkawaseblurpipelineplugin',
      'assets/EndSceneAssets/rexkawaseblurpipelineplugin.min.js',
      true,
    );
    this.load.plugin('rexwarppipelineplugin', 'assets/warp.min.js', true);

    this.load.atlas(
      'rippleHomeScreenAnim',
      'assets/anims/frogAnims/rippleHomeScreenAnim-0.png',
      'assets/anims/frogAnims/rippleHomeScreenAnim.json',
    );
    this.load.atlas(
      'randomRippleAnim',
      'assets/anims/frogAnims/randomRippleAnim-0.png',
      'assets/anims/frogAnims/randomRippleAnim.json',
    );
    this.load.atlas(
      'frogBlink',
      'assets/anims/frogAnims/frogBlink.png',
      'assets/anims/frogAnims/frogBlink.json',
    );

    this.load.atlas(
      'redFrogJumpAnim',
      'assets/anims/frogAnims/redFrogJumpAnim-0.png',
      'assets/anims/frogAnims/redFrogJumpAnim.json',
    );
    this.load.atlas(
      'greenFrogJumpAnim',
      'assets/anims/frogAnims/greenFrogJumpAnim-0.png',
      'assets/anims/frogAnims/greenFrogJumpAnim.json',
    );

    this.load.multiatlas(
      'riverRockRippleAnim',
      'assets/anims/frogAnims/riverRockRippleAnim.json',
      'assets/anims/frogAnims/',
    );

    this.load.multiatlas('birdAnim', 'assets/anims/frogAnims/birdAnim.json', 'assets/anims/frogAnims/');

    this.load.image('compass', 'assets/anims/rewardAnims/compass.png');

    this.load.audio('reward_reveal', 'assets/Audio/reward_reveal.mp3');
    this.load.audio('confettiaudio', 'assets/Audio/confetti.wav');
    this.load.audio('T1audio', 'assets/Audio/Tut-1.mp3');
    this.load.audio('T2audio', 'assets/Audio/Tut-2.mp3');
    this.load.audio('T3audio', 'assets/Audio/Tut-3.mp3');
    this.load.audio('correctaudio', 'assets/Audio/success.mp3');
    this.load.audio('ripcAudio', 'assets/Audio/water-splash-light-fizzle.mp3');
    this.load.audio('frogJumpAudio', 'assets/Audio/frogJump.mp3');
    this.load.audio('successAudio', 'assets/Audio/success.mp3');
    this.load.audio('waudio', 'assets/Audio/wrong.mp3');
    this.load.audio('sbgMusic', 'assets/Audio/small-river-flowing.mp3');
    this.load.audio('bgMusic', 'assets/Audio/waiting-for-the-sunrise.mp3');

    this.load.image('gameOver', 'assets/EndSceneAssets/Game Over.png');
    this.load.image('youWon', 'assets/EndSceneAssets/You won.png');
    this.load.image('correctIcon', 'assets/EndSceneAssets/correctIcon.png');
    this.load.image('incorrectIcon', 'assets/EndSceneAssets/incorrectIcon.png');
    this.load.image('retryButton', 'assets/EndSceneAssets/Retry Button.png');
    this.load.image('hover_retryButton', 'assets/EndSceneAssets/hover_Retry Button.png');
    this.load.image('hintIconMini', 'assets/EndSceneAssets/endHint.png');
    this.load.image('nextButton', 'assets/EndSceneAssets/nextButton.png');
    this.load.image('hover_nextButton', 'assets/EndSceneAssets/hover_nextbutton.png');
    this.load.image('replayButton', 'assets/EndSceneAssets/replayButton.png');
    this.load.image('hover_replayButton', 'assets/EndSceneAssets/hover_replayButton.png');
    this.load.image('endScreenOverlay', 'assets/EndSceneAssets/end screen.png');

    this.load.atlas(
      'hintFinalAnim',
      'assets/HintSceneAssets/hintFinalAnim.png',
      'assets/HintSceneAssets/hintFinalAnim.json',
    );

    this.load.image('hintClose', 'assets/HintSceneAssets/closeHint.png');
    this.load.image('hintText', 'assets/HintSceneAssets/hintText.png');
    this.load.image('hintText2', 'assets/HintSceneAssets/hintText2.png');
    this.load.image('overlay', 'assets/HintSceneAssets/overlay.png');

    this.load.image('okayButton', 'assets/EndSceneAssets/okaybutton.png');
    this.load.image('hover_okayButton', 'assets/EndSceneAssets/hover_okaybutton.png');
    this.load.image('disable_okayButton', 'assets/EndSceneAssets/disable_okaybutton.png');
    this.load.image('rewardEarned', 'assets/EndSceneAssets/Rewards earned!.png');
    this.load.image('rewardName', 'assets/EndSceneAssets/scuba.png');

    this.load.image('play_button', 'assets/StartSceneAssets/play_button.png');
    this.load.image('rocks', 'assets/StartSceneAssets/rocks.png');
    this.load.image('shadow', 'assets/StartSceneAssets/shadow.png');
    this.load.image('sleaf', 'assets/StartSceneAssets/startleaf.png');
    this.load.image('gameName', 'assets/StartSceneAssets/gameName.png');
    this.load.image('play_button_on', 'assets/StartSceneAssets/play_button_on.png');
    this.load.image('sbg', 'assets/StartSceneAssets/sbg.png');

    this.load.image('leftBank', 'assets/GameSceneAssets/leftBank.png');
    this.load.image('rightBank', 'assets/GameSceneAssets/rightBank.png');
    this.load.image('gfrog', 'assets/GameSceneAssets/gfrog.png');

    this.load.image('bubble', 'assets/GameSceneAssets/Bubble.png');
    this.load.image('bubble_c', 'assets/GameSceneAssets/Bubble_c.png');
    this.load.image('bubble_w', 'assets/GameSceneAssets/Bubble_w.png');
  }

  update() {}
}
